module.exports = __webpack_public_path__ + "static/media/nav-outreach-form-active.cc744422.svg";